<template>
    <div class="frame-wrap">
        <div class="frame-main">
            <div class="el-icon-close" @click="closeBtn" style="cursor:pointer;"></div>
            <div class="frame-main-con">
                <p class="frame-title">{{$t('business.fillRequest')}}</p>
                <div class="frame-top">
                    <img :src="$imgUrl + userInfo.avatar" alt="">
                    <div class="frame-infor">
                        <p class="frame-infor-title">{{userInfo.nickname}} 
                            <span v-if="langSet == 'zh' || userInfo.en_dutiesName.length == 0">{{userInfo.dutiesName}}</span>
                            <span v-if="langSet == 'en' && userInfo.en_dutiesName.length > 0">{{userInfo.en_dutiesName}}</span>
                        </p>
                        <p>{{userInfo.companyName}}</p>
                        <p>{{userInfo.mobile}}</p>
                    </div>
                    <img src="../../../assets/bianji.png" class="frame-edit" alt="" @click="editBtn">
                </div>
                <ul class="frame-list">
                    <li>
                        <p class="frame-list-title">{{$t('business.businessMode')}}<span>{{$t('business.multi')}}</span></p>
                        <div class="frame-label">
                            <p v-for="(item, index) in tradeChoose" :key="index" :class="[item.state ? 'active' : '']" @click="changeTrade(index)">
                                <span v-if="langSet == 'zh' || item.en_title.length == 0">{{item.title}}</span>
                                <span v-if="langSet == 'en' && item.en_title.length > 0">{{item.en_title}}</span>
                            </p>
                        </div>
                    </li>
                    <li>
                        <p class="frame-list-title">{{$t('business.role')}}</p>
                        <div class="frame-label">
                            <p :class="[demandCurrent == 2 ? 'active' : '']" @click="demandTrade(2)">{{$t('business.buyer')}}</p>
                            <p :class="[demandCurrent == 1 ? 'active' : '']" @click="demandTrade(1)">{{$t('business.exhibitor')}}</p>
                        </div>
                    </li>
                    <li class="uploadImgWrap">
                        <p class="frame-list-title">{{$t('business.demandPhoto')}}</p>
                        <div class="imglistwrap">
                            <div class="imglist">
                                <div class="img" v-for="(item, index) in imgList" :key="index">
                                    <img :src="$imgUrl + item.url" alt="">
                                    <p @click="delImg(index)"><img src="../../../assets/trash.png" alt=""></p>
                                </div>
                            </div>
                            <div class="upAddwrap" v-if="imgList.length < 3">
                                <input
                                    type="file"
                                    accept="image/*"
                                    @change="changeImage($event)"
                                    ref="avatarInput"
                                />
                            </div>
                        </div>
                        <p class="frame-list-title">{{$t('business.demandTag')}}</p>
                        <div class="label-list frame-label">
                            <p @click="demandLabel(index)" :class="[item.state ? 'active' : '']" v-for="(item, index) in labelList" :key="index">
                                <span v-if="langSet == 'zh' || item.en_labelName.length == 0">{{item.labelName}}</span>
                                <span v-if="langSet == 'en' && item.en_labelName.length > 0">{{item.en_labelName}}</span>
                            </p>
                        </div>
                    </li>
                    <li class="frame-lang">
                        <div class="frame-lang-list">
                            <p><span>*</span>{{$t('business.chinese')}}</p>
                            <el-input
                                resize="none"
                                type="textarea"
                                :rows="2"
                                :placeholder="placeholder"
                                maxlength="50"
                                v-model="chinese">
                            </el-input>
                            <div class="frame-lang-num">{{chinese.length}}/50</div>
                        </div>
                        <div class="frame-translate" @click="translate">翻译  ↑↓  Translate</div>
                        <div class="frame-lang-list">
                            <p><span>*</span>English</p>
                            <el-input
                                resize="none"
                                type="textarea"
                                :rows="2"
                                placeholder="Please type here"
                                maxlength="500"
                                v-model="english">
                            </el-input>
                            <div class="frame-lang-num">{{english.length}}/500</div>
                        </div>
                    </li>
                </ul>
                <div class="frame-publish" @click="submit">{{$t('business.publish')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getNeedLabel, getUser, getTranslate, getPublish, upImg } from "@/api/api";
export default {
    props:[ 'qyid','cpid' ],
    data() {
        return {
            tradeChoose:[
                {
                    title: '中国国内贸易',
                    en_title: 'Trade (within China)',
                    state: true
                },
                {
                    title: '国际贸易',
                    en_title: 'International Trade',
                    state: false
                }
            ],
            demandCurrent: 2,
            labelList:[],
            chinese: '',
            english: '',
            dialogImageUrl: '',
            dialogVisible: false,
            userInfo: {
                en_dutiesName:''
            },
            resData: {},
            langSet: '',
            placeholder: '',
            messageContent: '',
            imgList: [],
            baseUrl: 'https://itsh.indata3.com',
            pictureLoading: false
        }
    },
    created() {
    },
    mounted() {
        this.langSet = localStorage.getItem('languageSet') || 'zh';
        this.memberid = localStorage.getItem('memberid');
        this.placeholder = this.$t('business.inputContents');
        this.getLabel(this.memberid);
        this.getData();
        if(this.qyid == undefined){
            this.qyid = 0;
        }
        if(this.cpid == undefined){
            this.cpid = 0;
        }
    },
    computed:{

    },
    methods: {
        changeImage(event) {
            let file = event.target.files[0];
            let param = new FormData();
            param.append("imgFile", file); 
            upImg(param).then(res => {
                console.log(res.data)
                if (res.data.errno == 0) {
                    let imgurl = res.data.url;
                    let head = imgurl.replace(/\\/g, '/');
                    this.imgList.push({
                        'url': head,
                        'alt': '',
                        'sort': ''
                    })
                    //this.imgList = this.imgList;
                }
            });
        },
        delImg(index){
            this.imgList.splice(index,1);
        },
        closeBtn(){
            this.$emit('close-frame',false)
        },
        editBtn(){
            this.$router.push({name: 'dataEdit'});
        },
        closeMessageBtn(){
            this.isShowMessage = true;
        },
        changeTrade(index){
           let item = this.tradeChoose[index];
           item.state = ! item.state;
        },
        demandTrade(index){
            this.demandCurrent = index;
        },
        demandLabel(index){
            let item = this.labelList[index];
            item.state = ! item.state;
        },
        getLabel(memberid){
            let data = this.$qs.stringify({
                memberid
            })
            //console.log(this.memberid)
            getNeedLabel(data).then(res=>{
                //console.log(res.data)
                if(res.data.errno == 0){
                    res.data.rst.forEach(item => {
                        item.state = false;
                    })
                    this.labelList = res.data.rst;
                }   
            }).catch(err=>{
                console.log(err)
            })
        },
        getData(){
            let data = this.$qs.stringify({
                memberid: this.memberid,
                uuid:this.uuid
            })
            getUser(data).then(res=>{
                //console.log(res.data.rst)
                if(res.data.errno == 0){
                    this.userInfo = res.data.rst;
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        translate(){
            if(this.chinese.length != 0){
                let data = this.$qs.stringify({
                    lang1: "zh",
                    lang2: "en",
                    content: this.chinese
                })
                this.getTranslateData(data)
            }else if(this.chinese.length == 0 && this.english.length != 0){
                let data = this.$qs.stringify({
                    lang1: "en",
                    lang2: "zh",
                    content: this.english
                })
                this.getTranslateData(data)
            }else{
                this.$message('请输入描述内容');
            }
        },
        getTranslateData(data){
            getTranslate(data).then(res=>{
                //console.log(res)
                if(res.data.errno == 0){
                    if(this.chinese.length != 0){
                        this.english = res.data.rst;
                    }else if(this.chinese.length == 0 && this.english.length != 0){
                        this.chinese=res.data.rst;
                    }
                }else{
                    this.$message(res.data.errmsg);
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        publishBus(data){
            getPublish(data).then(res => {
                //console.log(res)
                if(res.data.errno == 0){
                    this.$router.push({name: 'business'});
                    this.$emit('close-frame',false);
                    this.$emit('reload',true);
                }else{
                    this.$message(res.data.errmsg);
                }
            }).catch(err => {
                console.log(err)
            })
        },
        submit(){
            let demandVal = '',
                tradeVal = '';
            this.tradeChoose.forEach((item, index) => {
                if (this.tradeChoose[index].state) {
                    let tradeIndex = Number(index) + 1;
                    tradeVal += tradeIndex + ','
                }
            })
            tradeVal = tradeVal.substring(0, tradeVal.lastIndexOf(','));
            for (var index in this.labelList) {
                if (this.labelList[index].state){
                    demandVal += this.labelList[index].id + ','
                }
            }
            demandVal = demandVal.substring(0, demandVal.lastIndexOf(','));
            if(tradeVal.length == 0){
                if(this.langSet == 'zh'){
                    this.$message('请选择贸易属性');
                }else{
                    this.$message('Please select trade attribute');
                }
            }else if(this.chinese.length == 0 || this.english.length == 0){
                //console.log(this.chinese)
                if(this.langSet == 'zh'){
                    this.$message('请输入内容！');
                }else{
                    this.$message('Please type here!');
                }
            }else{
                let data = this.$qs.stringify({
                    memberid: this.memberid,
                    type: tradeVal,
                    status: this.demandCurrent,
                    name: this.userInfo.nickname,
                    company: this.userInfo.companyName,
                    mobile: this.userInfo.mobile,
                    description: this.chinese,
                    en_description: this.english,
                    receive_companyid: this.qyid,
                    productid: this.cpid,
                    label_idstr: demandVal,
                    imgs: this.imgList,
                    isWeb: 1
                })
                this.publishBus(data);
            }
        }
    },
    watch: {
        $route (to, from) {
            this.$router.go(0)
        }
    }
}
</script>

<style lang="scss" scoped>
.el-upload--picture-card{width:134px;height:134px;background:rgba(198,197,197,1);border: 0 none;border-radius: 0;line-height: 160px;}
.el-upload--picture-card i{font-size: 53px;color: #7c7c7c;}
.el-upload-list--picture-card .el-upload-list__item{width:134px;height:134px;border-radius: 0;}
.frame-list li:last-child{border-bottom: 0 !important;}
.frame-label{line-height: 25px;}
.uploadImgWrap{
    .imglistwrap{
        display: flex;
        margin-bottom: 20px;
        .imglist{
            display: flex;
            .img{
                width: 134px;
                height: 134px;
                margin-right: 20px;
                position: relative;
                img{
                    width: 100%;
                    height: 100%;
                }
                p{
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    cursor: pointer;
                    background: rgba(0,0,0,0.5);
                    img{
                        width: 12px;
                        height: 14px;
                    }
                }
            }
        }
        .upAddwrap{
            width: 134px;
            height: 134px;
            background: url(../../../assets/add.png) no-repeat;
            background-size: 100% 100%;
            input{
                width: 100%;
                height: 100%;
                outline: none;
                opacity: 0;
                cursor: pointer;
            }
        }
    }
}
@media only screen and (max-width: 767px){
    .frame-wrap{
        background: transparent;
        .frame-main{
            width: 100%;
            height: 100%;
            padding: 0.2rem;
            border-radius: 0;
            overflow-x: hidden;
            .frame-main-con{
                width: 100%;
                padding: 0 0.2rem;
                box-sizing: border-box;
            }
        }
        .el-icon-close{font-size: 24px;text-align: right;display: block;}
        .frame-title{
            font-size: 16px;
        }
        .frame-top{
            width: 100%;
            margin:0.2rem 0;
            padding: 0.2rem 0.5rem 0.2rem 0.2rem;
            .frame-infor{
                .frame-infor-title{font-size: 16px;}
            }
        }
        .frame-list{
            li{
                padding: 0.2rem 0;
                .frame-list-title{font-size: 16px;padding-bottom: 0.25rem;}
            }
        } 
        .frame-label p{font-size: 14px;margin-right: 0.3rem;}
        .label-list p{margin-bottom: 0.2rem;}
        .uploadImgWrap .imglistwrap .upAddwrap,.uploadImgWrap .imglistwrap .imglist .img{width: 2.1rem;height: 2.1rem;}
        .uploadImgWrap .imglistwrap .imglist .img{margin-right: 0.2rem;}
    }
    
}
</style>